import { parseNumberByPrecision } from './parseNumberByPrecision';
import { mathConfig, mathJS } from './mathFormat';

export const handleNumpadButtonsClick = (
  setBetAmount,
  betAmount,
  limits,
  precision,
  option = false
) => {
  let changedBetAmount = 0;
  if (option) {
    changedBetAmount = +mathJS.format(+betAmount + (limits?.minBet || 0), mathConfig);
  } else {
    changedBetAmount = +mathJS.format(+betAmount - (limits?.minBet || 0), mathConfig);
    changedBetAmount = changedBetAmount > limits?.minBet ? changedBetAmount : limits?.minBet;
    if (limits.maxBet) {
      changedBetAmount = changedBetAmount < limits.maxBet ? changedBetAmount : limits.maxBet;
    }
  }
  setBetAmount(parseNumberByPrecision(1, changedBetAmount, precision));
};
